<template>
  <div>
    <div class="app__header-menu">
        <div class="app__nav-menu">
          <div>
            <button  style="display: none;"
              id="bt_check"
              type="button"
              aria-controls="navbar-default"
              aria-expanded="false"
            >
              <span>Open main menu</span>
              <svg
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
          <div>
            <a @click="gotoRoute('/')" href="javascript:void(0)" >
              <img
                src="/static/img/logo/logo.png"
                alt="logo"
                class="img-logo"
              />
            </a>
          </div>
          <div class="app__menu-linkButton">
            <div>
              <!-- <a href="./login"> <i class="fa-solid fa-right-to-bracket flip-icon" style="margin-right: 8px;"></i> เข้าสู่ระบบ</a> -->
            </div>
            <div v-if="nowPage != 'Register' && nowPage != 'Login'">
              <a href="javascript:void(0)" 
               @click="gotoRoute('/register')"
                class="app__buttonlink-menu w-40 justify-center fill-black hover:fill-app_yellow"
                >สมัครสมาชิก
                <i
                  class="fa-solid fa-person-circle-plus"
                  style="margin-left: 8px"
                ></i>
              </a>
            </div>
          </div>
        </div>
        <div class="app__nav-menu-mobile block md:hidden">
          <div>
            <a href="javascript:void(0)"  @click="gotoRoute('/')">
              <img
              src="/static/img/logo/logo.png"
                alt="logo"
                class="img-logo"
              />
            </a>
          </div>
          <div>
            <button style="display: none;"
              id="bt_check-mobile"
              type="button"
              aria-controls="navbar-default"
              aria-expanded="false"
            >
              <span>Open main menu</span>
              <svg
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                  clip-rule="evenodd"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    <router-view />
 
  </div>

</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { BankMixins } from "@/mixins/BankService.js";
import api from "@/services/index.js";
import Header from "@/components/layout/Header";

import Footer from "@/components/layout/Footer";
import LoginForm from "@/components/form/LoginForm";
import RegisterForm from "@/components/form/RegisterForm";

export default {
  name: "App",
  data() {
    return {
      Prefix: [],
      category:"Casino",
      nowPage: this.$route.name,
    };
  },
  components: { Header, Footer,LoginForm,RegisterForm },
  computed: {
    ...mapGetters(["getAppId", "getError", "getLoading", "getLineId"]),
  },
  methods: {
    ...mapMutations([
      "setAlertMessage",
      "setAlertImage",
      "setLogoUrl",
      "setAppId",
      "setLineId",
      "setPhotoCashback",
      "setPhotoAffiliate",
    ]),
    gotoRoute(route) {
      this.$router.push(route);
    },
    async setFavicons(favImg) {
      let headTitle = document.querySelector("head");
      let setFavicon = document.createElement("link");
      setFavicon.setAttribute("rel", "shortcut icon");
      setFavicon.setAttribute("href", favImg);
      headTitle.appendChild(setFavicon);
    },
    async InitConfig() {
      this.setAppId(this.Prefix.appId);
      this.setPhotoCashback(this.Prefix.cashBack.Image || null);
      this.setPhotoAffiliate(this.Prefix.Affiliate.Image || null);
      this.setAppId(this.Prefix.appId);
      this.setLineId(this.Prefix.LineId);
      this.setLogoUrl(this.Prefix.logoUrl);
      this.setFavicons(this.Prefix.logoUrl);
      this.setAlertImage(this.Prefix.alertyImage);
      this.setAlertMessage(this.Prefix.alertyMessage);
      document
        .querySelector('meta[name="description"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:title"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:description"]')
        .setAttribute("content", `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`);
      document
        .querySelector('meta[name="og:image"]')
        .setAttribute("content", this.Prefix.logoUrl);
      document.documentElement.setAttribute(
        "class",
        `${this.Prefix.theme}-theme`
      );
      document.documentElement.setAttribute("lang", `th`);
      document.title = `${this.getAppId} - เว็บไซต์อันดับ 1 ในไทย`;
    },
  },
  async beforeCreate() {
    await api.get("/v2/prefix").then((v) => {
      if (v.success == true) {
        this.Prefix = v.data;
        this.InitConfig();
      } else {
      }
    });
  },

  watch: {
    $route() {
      this.nowPage = this.$route.name;
    },
    '$route.params.category': function (newParamValue, oldParamValue) {
      this.category = newParamValue
      // Do something when the query parameter changes
    }
  },
};
</script>

<style>
.register {
  font-family: "db helvethaicamon x" !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue